import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { ExploreData } from "../../core/json/ExploreJson";
import { FollowData } from "../../pages/explore/top-project-card/TopProjectCard";

export interface IExploreState {
  exploreData: any;
  searchKey: any;
  searchedProfileList: Array<any>;
  isLoading: boolean;
  isProfileFetched: boolean;
  isProjectsFetched: boolean;
  isPostsFetched: boolean;
  exploreTabValue: number;
  searchedProjects: any;
  searchedPosts: any;
  searchedArtists: any;
}

const initialState: IExploreState = {
  exploreData: ExploreData,
  searchKey: "",
  searchedProfileList: [],
  searchedPosts: {},
  searchedProjects: {},
  searchedArtists: {},
  isLoading: false,
  isProfileFetched: false,
  isProjectsFetched: false,
  isPostsFetched: false,
  exploreTabValue: 0,
};

export const exploreRedux = createSlice({
  name: "exploreRedux",
  initialState,
  reducers: {
    setExploreState: (state: any, action: any) => {
      const newState = {
        ...state,
      };
      newState[action.payload.key] = action.payload.value;
      return newState;
    },

    searchProfilesIInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProfileFetched: true,
      };
      return newState;
    },

    searchProfilesIInExploreSuccess: (state: any, action: any) => {
      const previousProfilesData: any = current(state?.searchedProfileList);
      const response = action?.payload?.data;

      const responseData: any =
        response?.currentPage === 1 ? [] : previousProfilesData.responseData;
      const newState = {
        ...state,
        searchedProfileList: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...responseData, ...response?.responseData],
        },
        isLoading: false,
        isProfileFetched: false,
      };
      return newState;
    },

    searchProfilesIInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileFetched: false,
      };
      return newState;
    },

    serachPostsInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPostsFetched: true,
      };
      return newState;
    },

    serachPostsInExploreSuccess: (state: any, action: any) => {
      const previousProfilesData: any = current(state?.searchedPosts);
      const response = action?.payload?.data;

      const responseData: any =
        response?.currentPage === 1 ? [] : previousProfilesData.responseData;
      const newState = {
        ...state,
        searchedPosts: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...responseData, ...response?.responseData],
        },
        isLoading: false,
        isPostsFetched: false,
      };
      return newState;
    },

    serachPostsInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPostsFetched: false,
      };
      return newState;
    },

    serachProjectsInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProjectsFetched: true,
      };
      return newState;
    },

    serachProjectsInExploreSuccess: (state: any, action: any) => {
      const previousProfilesData: any = current(state?.searchedProjects);
      const response = action?.payload?.data;
      const responseData: any =
        response?.currentPage === 1 ? [] : previousProfilesData?.responseData;
      const newState = {
        ...state,
        searchedProjects: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...responseData, ...response?.responseData?.projectDetails],
        },
        isLoading: false,
        isProjectsFetched: false,
      };
      return newState;
    },

    serachProjectsInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectsFetched: false,
      };
      return newState;
    },

    // search all projects
    serachAllProjectsInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProjectsFetched: true,
      };
      return newState;
    },

    serachAllProjectsInExploreSuccess: (state: any, action: any) => {
      const previousProfilesData: any = current(state?.searchedProjects);
      const response = action?.payload?.data;
      const responseData: any =
        response?.currentPage === 1 ? [] : previousProfilesData?.responseData;
      const newState = {
        ...state,
        searchedProjects: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...responseData, ...response?.responseData?.projectDetails],
        },
        isLoading: false,
        isProjectsFetched: false,
      };
      return newState;
    },

    serachAllProjectsInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectsFetched: false,
      };
      return newState;
    },

    //search artists
    serachArtistInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    serachArtistInExploreSuccess: (state: any, action: any) => {
      // const previousProfilesData: any = current(state?.searchedArtists);
      const response = action?.payload?.data;
      // const responseData: any =
      //   response?.currentPage === 1 ? [] : previousProfilesData.responseData;
      const newState = {
        ...state,
        searchedArtists: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...response?.responseData],
        },
        isLoading: false,
      };
      return newState;
    },

    serachArtistInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // filters in explore

    //project filter
    projectFilterInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    projectFilterInExploreSuccess: (state: any, action: any) => {
      const previousProfilesData: any = current(state?.searchedProjects);
      const response = action?.payload?.data;
      const responseData: any =
        response?.currentPage === 1 ? [] : previousProfilesData?.responseData;
      const newState = {
        ...state,
        searchedProjects: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...response?.responseData?.projectFilterResponseDtoList],
        },
        isLoading: false,
        isProjectsFetched: false,
      };
      return newState;
    },

    projectFilterInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    //post filter
    postFilterInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    postFilterInExploreSuccess: (state: any, action: any) => {
      const previousProfilesData: any = current(state?.searchedProjects);
      const response = action?.payload?.data;
      const responseData: any =
        response?.currentPage === 1 ? [] : previousProfilesData?.responseData;
      const newState = {
        ...state,
        searchedPosts: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...responseData, ...response?.responseData],
        },
        isLoading: false,
        isPostsFetched: false,
      };
      return newState;
    },

    postFilterInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    //artist filter
    userFilterInExploreRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    userFilterInExploreSuccess: (state: any, action: any) => {
      const previousProfilesData: any = current(state?.searchedProjects);
      const response = action?.payload?.data;
      console.log(response, "responsee")
      const newState = {
        ...state,
        searchedProfileList: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...response?.responseData],
        },
        isLoading: false,
      };
      return newState;
    },

    userFilterInExploreFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },



    followUserInExploreProjectsSuccess: (state: any, action: PayloadAction<FollowData>) => {
      // console.log(action.payload, "action.payload")
      const newState = {
        ...state,
        searchedProjects: {
          ...state.searchedProjects,
          responseData: state?.searchedProjects?.responseData?.map((item: {
            projectOwnerDetails: any; id: any;
          }) =>
            item?.projectOwnerDetails?.userId === action?.payload?.userIdToFollow ?
              {
                ...item,
                projectOwnerDetails: {
                  ...item?.projectOwnerDetails,
                  isFollowing: action.payload?.isFollowing
                }
              }
              : item)
        }
      };
      return newState;
    }
  },
});

export const {
  setExploreState,

  searchProfilesIInExploreRequest,
  searchProfilesIInExploreSuccess,
  searchProfilesIInExploreFailure,

  serachPostsInExploreRequest,
  serachPostsInExploreSuccess,
  serachPostsInExploreFailure,

  serachProjectsInExploreRequest,
  serachProjectsInExploreSuccess,
  serachProjectsInExploreFailure,

  serachArtistInExploreRequest,
  serachArtistInExploreSuccess,
  serachArtistInExploreFailure,

  projectFilterInExploreRequest,
  projectFilterInExploreSuccess,
  projectFilterInExploreFailure,

  postFilterInExploreRequest,
  postFilterInExploreSuccess,
  postFilterInExploreFailure,

  userFilterInExploreRequest,
  userFilterInExploreSuccess,
  userFilterInExploreFailure,

  // update follow status on real time
  followUserInExploreProjectsSuccess

} = exploreRedux.actions;

export default exploreRedux.reducer;
